export const TIPO_OS_NAMES = {
  C: 'Corretiva',
  I: 'Instalação',
  D: 'Desinstalação',
  E: 'Estoque',
  S: 'Preventiva',
  B: 'Balcão',
  R: 'Retorno/Recarga',
  A: 'Aferição',
};

const LABEL_TO_LETTER = Object.fromEntries(
  Object.entries(TIPO_OS_NAMES).map(([letter, label]) => [label, letter])
);

const PREVENTIVA_TO_LETTER = {
  E: 'E',
  B: 'B',
  A: 'A',
  R: 'R',
  D: 'D',
  I: 'I',
  S: 'S',
  N: 'C',
  C: 'C',
};

export function preventivaToTipoLetter(preventiva) {
  const key = String(preventiva ?? 'N').trim().toUpperCase();
  return PREVENTIVA_TO_LETTER[key] || 'C';
}

export function normalizeTipoOSKey(value) {
  if (value == null || value === '') return null;
  const v = String(value).trim();
  if (TIPO_OS_NAMES[v]) return v;
  if (LABEL_TO_LETTER[v]) return LABEL_TO_LETTER[v];
  const byLabel = Object.entries(TIPO_OS_NAMES).find(
    ([, label]) => label.toLowerCase() === v.toLowerCase()
  );
  if (byLabel) return byLabel[0];
  if (v.length === 1 && PREVENTIVA_TO_LETTER[v.toUpperCase()]) {
    return PREVENTIVA_TO_LETTER[v.toUpperCase()];
  }
  return v;
}

export function normalizeTipoOSSelection(values) {
  if (!Array.isArray(values)) return [];
  return [...new Set(values.map(normalizeTipoOSKey).filter(Boolean))];
}

export function getOrderTipoOSLetter(ordem, getServiceTypeFromPreventiva) {
  const preventiva = ordem.TB02115_PREVENTIVA ?? ordem.tipoOS;
  const fromTipo = normalizeTipoOSKey(ordem.tipo);
  if (fromTipo && TIPO_OS_NAMES[fromTipo]) return fromTipo;

  if (getServiceTypeFromPreventiva) {
    return normalizeTipoOSKey(getServiceTypeFromPreventiva(preventiva || 'N')) || 'C';
  }

  return preventivaToTipoLetter(preventiva || 'C');
}

export function orderMatchesTipoOSFilter(ordem, selectedTipoOS, getServiceTypeFromPreventiva) {
  const keys = normalizeTipoOSSelection(selectedTipoOS);
  if (keys.length === 0) return true;
  return keys.includes(getOrderTipoOSLetter(ordem, getServiceTypeFromPreventiva));
}

/** Flags LCY_SYS_USERS_LOAD → letras do filtro/board (C = Corretiva). */
export const USER_LOAD_OS_FLAG_TO_BOARD_LETTER = {
  os_normal: 'C',
  os_install: 'I',
  os_preventive: 'S',
  os_reading: 'A',
  os_uninstall: 'D',
  os_return: 'R',
  os_stock: 'E',
  os_counter: 'B',
};

export function userOsLoadFlagsToBoardLetters(osTypes) {
  if (!osTypes || typeof osTypes !== 'object') return [];
  const out = [];
  Object.keys(USER_LOAD_OS_FLAG_TO_BOARD_LETTER).forEach((key) => {
    const v = osTypes[key];
    if (v === true || v === 1 || v === '1') out.push(USER_LOAD_OS_FLAG_TO_BOARD_LETTER[key]);
  });
  return out;
}

/** Restrição asstec_openos_type_only: ordem está entre os tipos permitidos ao usuário. */
export function orderMatchesUserOsTypeRestriction(ordem, allowedLetters, getServiceTypeFromPreventiva) {
  if (!Array.isArray(allowedLetters)) return true;
  if (allowedLetters.length === 0) return false;
  return allowedLetters.includes(getOrderTipoOSLetter(ordem, getServiceTypeFromPreventiva));
}
